import React from 'react';

interface Props { reason?: string; }

export default function InvalidLink({ reason }: Props) {
    return (
        <div className="bank-card bank-invalid">
            <h1>Link non valido</h1>
            <p>{reason || 'Il link che hai aperto non è riconosciuto. Controlla l\'email originale o contatta la struttura.'}</p>
            <hr />
            <h2>Invalid link</h2>
            <p>The link you opened is not recognized. Check the original email or contact the property.</p>
        </div>
    );
}
